import { Metrics, PartiesGuestData, ServicesResourcesMetrics } from '../models';

export class AnalyticsService {
  getEmptyMetrics(): Metrics {
    return {
      totalWaitTime: 0,
      totalTurnTime: 0,
      totalParties: 0,
      totalCustomers: 0,
      totalCompleted: 0,
      totalCancels: 0,
      totalSms: 0,
      totalVoice: 0,
      onTimeServed: 0,
      totalInbound: 0,
      responseTime: 0,
      notifiedParties: 0,
      avgResponseTime: 0,
      avgSize: 0,
      avgWait: 0,
      avgTurnTime: 0,
      pctCanceled: 0,
      pctOnTime: 0,
    };
  }

  getEmptyServicesResourcesMetrics(): ServicesResourcesMetrics {
    return {
      services: [],
      resources: [],
      servicesAndResources: [],
    };
  }

  calcSummaryStats(metrics) {
    metrics.avgWait = Math.floor(metrics.totalWaitTime / metrics.totalParties / 1000 / 60) || 0;
    metrics.avgResponseTime = Math.floor(metrics.responseTime / metrics.notifiedParties / 1000 / 60) || 0;
    metrics.avgSize = metrics.totalCustomers / metrics.totalParties || 0;
    metrics.pctCanceled = metrics.totalCancels / (metrics.totalParties + metrics.totalCancels) * 100 || 0;
    metrics.pctOnTime = metrics.onTimeServed / metrics.totalParties * 100 || 0;
    metrics.avgTurnTime = Math.floor(metrics.totalTurnTime / metrics.totalCompleted / 1000 / 60) || 0;

    return metrics;
  }

  calcServicesAndResourcesSummaryStats(
    record: PartiesGuestData,
    metrics: PartiesGuestData[],
    checkByServiceAndResourcesId = false,
  ): void {
    let recordIdx = metrics.findIndex(({ id }) => record.id === id);

    if (checkByServiceAndResourcesId) {
      recordIdx = metrics.findIndex(({ id, comboId }) => record.id === id && record.comboId === comboId);
    }

    if (recordIdx >= 0) {
      const currentRecordGuests = metrics[recordIdx].guests;
      const currentRecordParties = metrics[recordIdx].parties;

      metrics[recordIdx] = {
        id: record.id,
        guests: currentRecordGuests + record.guests,
        parties: currentRecordParties + record.parties,
        comboId: checkByServiceAndResourcesId ? record.comboId : null,
      };
    } else {
      metrics.push(record);
    }
  }
}

export const SHARED_ANALYTICS_PROVIDER = 'SHARED_ANALYTICS_PROVIDER';
